<template>
  <div class="page-cart">
    <h1 class="title">Mi carrito</h1>
    <template v-if="Object.values($store.state.cart).length > 0">
      <div class="columns">
        <div class="column is-7">
          <div class="box">
            <div class="wraper-footer">
              <div class="is-space-bet has-text-grey">
                <p><i class="fas fa-shield-alt"></i> Compra protegida</p>
                <p>Pago cifrado y verificado por <strong class="is-purple">MercadoPago</strong></p>
              </div>
            </div>
          </div>
        </div>
        <div class="column is-5">
          <div class="box">
            <h2 class="title is-purple is-size-5">Resumen del pedido</h2>
            <CartList v-for="item in items" :key="item.product.id" :item="item" />
            <div class="end-pay">
              <div class="is-space-bet">
                <p>Total articulos a comprar</p>
                <p>{{ cartTotalLength }}</p>
              </div>
              <div class="is-space-bet">
                <p>Subtotal</p>
                <p>{{ cartTotalQuantity }}</p>
              </div>
              <hr />
              <div class="buttons is-space-bet">
                <router-link to="/cart/checkout">
                  <button class="button btn mx-1">
                    Verificar compra
                  </button>
                </router-link>
                <button class="button is-danger mx-1" @click.once="clearCart">
                  Vaciar carrito
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="columns is-multiline is-wrapper">
        <div class="column is-10">
          <div class="notification is-warning mb-6">
            <p><strong>Carrito vacio!!</strong></p>
            <p>
              Te recomendamos que sigas conectado con nosotros y puedas
              encontrar lo que buscas..!
            </p>
            <p><router-link to="/products">Ir de Shopping</router-link></p>
          </div>
        </div>
        <div class="column is-2 is-float">
          <img src="static/img/carro-vacio.png" alt="" />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { computed } from "@vue/reactivity";
import CartList from "@/components/CartList.vue";
import FormCreditCard from "@/components/FormCreditCard.vue";

export default {
  name: "Cart",
  components: {
    CartList,
    FormCreditCard,
  },
  data() {
    return {
      items: {},
    };
  },
  beforeMount() {
    const self = this;
    document.title = "Mi carrito | Shoper.co";
    self.items = self.$store.state.cart;
  },
  methods: {
    removeError(){
      this.errors = []
    },
    clearCart() {
      this.$store.commit("clearCart");
    },
  },
  computed: {
    cartTotalLength() {
      return computed(() => this.$store.getters.getCartTotalLength);
    },
    cartTotalQuantity() {
      const amount = Object.values(this.items).reduce(
        (acc, item) => acc + item.quantity * item.product.price,
        0
      );
      return accounting.formatMoney(amount, "$", 0, ".", ",");
    },
  },
};
</script>

<style lang="scss" scoped>
.end-pay {
  padding: 0 1rem;
}
.wraper-footer{
  padding: 1rem;
  border: #745192 1px solid;
  border-radius: 3px;
  .fas {
    color: #22e25c9f;
  }
}
.is-wrapper {
  position: relative;
}
.btn.btn-active {
  color: #fff;
  background-color: #745192;
}
.is-float {
  img {
    width: 100%;
  }
}
.btn {
  color: #745192;
  background-color: #fff;
  border: #745192 solid 1px;
  transition: all linear 0.1s;
  &:hover {
    background-color: #745192;
    color: #fff;
  }
}
</style>